var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 484.343 471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-284bff58-bf2c-42e8-853f-8c5574598704 {\n        fill: #f5832d;\n      }\n\n      .uuid-8146b376-fe32-487e-8739-59dd6f69a4c3 {\n        fill: #fab116;\n      }\n\n      .uuid-1c607554-54de-4cf2-912a-b2912f943260 {\n        fill: #00c7e5;\n      }\n\n      .uuid-ba8b48a5-4374-488c-a571-0461e4356078 {\n        fill: #fff;\n      }\n\n      .uuid-76eabbc1-6a62-4233-b964-323eae51ce82 {\n        fill: #ff991f;\n      }\n\n      .uuid-1bf85ed4-9b78-4b76-ba96-8705f2566ec1 {\n        fill: #ffc400;\n      }\n\n      .uuid-c52e7266-2017-4be4-b9b3-b14ca46e82cb {\n        fill: #fcb123;\n      }\n\n      .uuid-7a563a79-2a0d-45a6-a4b3-036728c808d2 {\n        fill: #57d9a3;\n      }\n\n      .uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a {\n        fill: #4c9aff;\n      }\n\n      .uuid-5c653395-6399-4a88-8282-16429f8407e0 {\n        fill: #2684ff;\n      }\n\n      .uuid-e643f183-4ef1-497b-a48d-fea2e60d7aba {\n        fill: url(#uuid-5748c449-4e19-4213-a078-72bb4efc3e75);\n      }\n\n      .uuid-04bbcc1a-bb48-4990-bb2e-b8d1e7642f4d {\n        fill: url(#uuid-05dff7f8-c181-4176-8b84-989c64b2fb8a);\n      }\n\n      .uuid-08cf1e04-e64a-430d-bcfd-cf7096b83ea3 {\n        fill: #a1acb7;\n        fill-rule: evenodd;\n      }\n\n      .uuid-928c7b4e-355b-465d-9710-dc4b337efd55 {\n        fill: url(#uuid-512913b6-0016-4106-bf45-d212a08751e5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-05dff7f8-c181-4176-8b84-989c64b2fb8a",
    x1: 0,
    y1: 232.518,
    x2: 453.429,
    y2: 232.518,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#deebff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#deebff",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#deebff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#deebff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#deebff",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deebff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5748c449-4e19-4213-a078-72bb4efc3e75",
    "data-name": "New Gradient Swatch 31",
    x1: 105.515,
    y1: 151,
    x2: 260.66,
    y2: 151,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-512913b6-0016-4106-bf45-d212a08751e5",
    "data-name": "New Gradient Swatch 31",
    x1: 239.515,
    y1: 321.283,
    x2: 394.66,
    y2: 321.283,
    xlinkHref: "#uuid-5748c449-4e19-4213-a078-72bb4efc3e75"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-64141e5e-869c-4bcc-bfb7-dc7d8b941166",
    "data-name": "Layer 5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-bd881bf0-c874-4d75-9908-068b399f651e",
    "data-name": "Layer 1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-325a9ddd-da50-4b9f-b59c-92f75edb56b3",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-586c83ad-7942-45e9-9a72-c1dd8314edec",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-26d17098-d911-4696-950d-68b9fa2f19e4",
    "data-name": "Layer 8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "uuid-f141e202-1abf-400a-a1db-e8ea8ec778e2",
    "data-name": "Layer 8 copy"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-04bbcc1a-bb48-4990-bb2e-b8d1e7642f4d",
    d: "M241.196,53.462c-10.132-2.019-21.506-3.388-29.945,2.911-11.027,8.231-11.801,25.333-19.693,36.948-9.463,13.927-27.606,17.68-43.707,16.347-16.101-1.333-31.896-6.593-48.041-6.139-16.144,.455-33.839,8.724-38.822,25.073-4.475,14.683,2.281,32.291-5.387,45.394-7.619,13.02-24.859,14.125-37.007,22.379C2.003,207.648-3.218,232.098,1.865,252.335c5.082,20.238,18.351,36.945,32.371,51.649,68.365,71.699,164.822,112.067,260.768,109.133,25.717-.786,51.607-4.613,75.564-14.596,23.957-9.983,45.965-26.453,60.42-49.101,17.946-28.117,23.044-63.483,22.387-97.465-.623-32.225-6.174-64.846-20.313-93.35-8.268-16.668-19.603-31.77-33.488-43.522-13.408-11.349-25.925-13.835-41.308-19.498-19.172-7.058-37.112-18.028-56.436-25.089-19.788-7.23-40.069-12.934-60.634-17.033Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1bf85ed4-9b78-4b76-ba96-8705f2566ec1",
    cx: 316.787,
    cy: 70.084,
    r: 23.015,
    transform: "translate(153.945 350.705) rotate(-72.349)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    cx: 62.456,
    cy: 242.121,
    r: 23.015
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1bf85ed4-9b78-4b76-ba96-8705f2566ec1",
    cx: 38.398,
    cy: 161.184,
    r: 12.194,
    transform: "translate(-127.296 161.522) rotate(-76.717)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-8146b376-fe32-487e-8739-59dd6f69a4c3",
    cx: 415.939,
    cy: 235.992,
    r: 9.813
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-5c653395-6399-4a88-8282-16429f8407e0",
    cx: 363.173,
    cy: 77.742,
    r: 7.658,
    transform: "translate(205.281 413.909) rotate(-76.924)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-5c653395-6399-4a88-8282-16429f8407e0",
    cx: 81.622,
    cy: 155.303,
    r: 4.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-76eabbc1-6a62-4233-b964-323eae51ce82",
    d: "M394.451,122.946l7.558,1.433c.817,.155,1.661-.02,2.349-.487l20.861-14.164c1.435-.974,1.808-2.927,.834-4.362l-6.102-8.986c-.974-1.435-2.927-1.808-4.362-.834l-20.861,14.164c-.688,.467-1.162,1.187-1.32,2.004l-1.456,7.553c-.329,1.707,.791,3.356,2.498,3.68Zm3.477-3.684c-1.31-.523-1.948-2.009-1.425-3.319,.523-1.31,2.009-1.948,3.319-1.425,1.31,.523,1.948,2.009,1.425,3.319-.523,1.31-2.009,1.948-3.319,1.425Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-76eabbc1-6a62-4233-b964-323eae51ce82",
    d: "M391.073,126.713c-1.782,0-3.566-.64-4.833-1.908-2.461-2.461-2.552-6.867-.196-9.428,1.273-1.384,3.153-2.265,5.294-2.48,3.344-.337,6.778,1.04,8.963,3.593,.115,.134,.099,.337-.035,.452-.134,.115-.336,.1-.452-.035-2.051-2.396-5.277-3.689-8.412-3.372-1.984,.2-3.72,1.008-4.886,2.277-2.135,2.32-2.052,6.312,.177,8.541,2.229,2.23,6.22,2.315,8.542,.181,.13-.119,.333-.111,.453,.019,.12,.13,.111,.333-.019,.453-1.242,1.142-2.918,1.708-4.595,1.708Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    d: "M15.435,221.036c-.177,0-.32-.143-.32-.32v-2.894c0-.177,.143-.32,.32-.32s.32,.143,.32,.32v2.894c0,.177-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    d: "M15.435,230.265c-.177,0-.32-.143-.32-.32v-2.894c0-.177,.143-.32,.32-.32s.32,.143,.32,.32v2.894c0,.177-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    d: "M21.496,224.204h-2.894c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h2.894c.177,0,.32,.143,.32,.32s-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    d: "M12.267,224.204h-2.894c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h2.894c.177,0,.32,.143,.32,.32s-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    d: "M17.675,221.964c-.082,0-.164-.031-.227-.094-.125-.125-.125-.328,0-.453l2.046-2.046c.125-.125,.328-.125,.453,0,.125,.125,.125,.328,0,.453l-2.046,2.046c-.063,.063-.145,.094-.227,.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    d: "M11.149,228.49c-.082,0-.164-.031-.227-.094-.125-.125-.125-.328,0-.453l2.046-2.046c.125-.125,.328-.125,.453,0,.125,.125,.125,.328,0,.453l-2.046,2.046c-.063,.063-.145,.094-.227,.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    d: "M19.721,228.49c-.082,0-.164-.031-.227-.094l-2.046-2.046c-.125-.125-.125-.328,0-.453,.125-.125,.328-.125,.453,0l2.046,2.046c.125,.125,.125,.328,0,.453-.063,.063-.145,.094-.227,.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c607554-54de-4cf2-912a-b2912f943260",
    d: "M13.195,221.964c-.082,0-.164-.031-.227-.094l-2.046-2.046c-.125-.125-.125-.328,0-.453,.125-.125,.328-.125,.453,0l2.046,2.046c.125,.125,.125,.328,0,.453-.063,.063-.145,.094-.227,.094Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a",
    x: 32.087,
    y: 63.801,
    width: 302,
    height: 174.399,
    rx: 17.79,
    ry: 17.79,
    transform: "translate(334.087 -32.087) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-e643f183-4ef1-497b-a48d-fea2e60d7aba",
    x: 105.515,
    y: 9.705,
    width: 155.145,
    height: 282.591,
    rx: 13.087,
    ry: 13.087
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M245.647,36.078h-13.656c-.145,0-.273-.098-.31-.238l-3.201-12.071h-2.013c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h2.259c.145,0,.272,.098,.31,.238l3.201,12.071h13.41c.177,0,.32,.143,.32,.32s-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M234.447,39.817c-1.196,0-2.168-.973-2.168-2.168s.973-2.168,2.168-2.168,2.168,.973,2.168,2.168-.973,2.168-2.168,2.168Zm0-3.696c-.842,0-1.528,.685-1.528,1.528s.685,1.528,1.528,1.528,1.527-.685,1.527-1.528-.685-1.528-1.527-1.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M243.26,39.817c-1.196,0-2.168-.973-2.168-2.168s.973-2.168,2.168-2.168,2.168,.973,2.168,2.168-.973,2.168-2.168,2.168Zm0-3.696c-.842,0-1.528,.685-1.528,1.528s.685,1.528,1.528,1.528,1.527-.685,1.527-1.528-.685-1.528-1.527-1.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M245.948,32.768h-14.836c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h14.565l1.197-7.064h-17.805c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h18.184c.094,0,.184,.042,.245,.114,.061,.072,.087,.167,.071,.26l-1.306,7.705c-.026,.154-.16,.267-.316,.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M246.601,28.915h-16.51c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h16.51c.177,0,.32,.143,.32,.32s-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M238.346,32.768c-.177,0-.32-.143-.32-.32v-7.705c0-.177,.143-.32,.32-.32s.32,.143,.32,.32v7.705c0,.177-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M242.224,32.768h-.025c-.176-.015-.308-.169-.294-.345l.602-7.705c.014-.176,.17-.308,.344-.294,.176,.014,.308,.168,.294,.344l-.602,7.705c-.013,.168-.154,.295-.319,.295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M234.651,32.768c-.165,0-.306-.127-.319-.295l-.602-7.705c-.014-.176,.118-.331,.294-.344,.174-.014,.331,.118,.344,.294l.602,7.705c.014,.176-.118,.331-.294,.344h-.025Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a",
    d: "M203.958,2.257h-20.959c-.097,0-.192,.012-.289,.017-.096-.005-.191-.017-.288-.017h-20.959c-3.284,0-5.982,3.165-6.027,7.07-.045,3.905,2.581,7.07,5.864,7.07h20.959c.097,0,.192-.012,.288-.017,.096,.005,.191,.017,.289,.017h20.959c3.284,0,5.982-3.165,6.027-7.07,.045-3.904-2.581-7.07-5.864-7.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a",
    x: 167.371,
    y: 234.084,
    width: 299.434,
    height: 174.399,
    rx: 17.79,
    ry: 17.79,
    transform: "translate(638.371 4.196) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-928c7b4e-355b-465d-9710-dc4b337efd55",
    x: 239.515,
    y: 181.189,
    width: 155.145,
    height: 280.189,
    rx: 13.087,
    ry: 13.087
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M379.647,204.078h-13.656c-.145,0-.273-.098-.31-.238l-3.201-12.071h-2.013c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h2.259c.145,0,.272,.098,.31,.238l3.201,12.071h13.41c.177,0,.32,.143,.32,.32s-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M368.447,207.817c-1.196,0-2.168-.973-2.168-2.168s.973-2.168,2.168-2.168,2.168,.973,2.168,2.168-.973,2.168-2.168,2.168Zm0-3.696c-.842,0-1.528,.685-1.528,1.528s.685,1.528,1.528,1.528,1.527-.685,1.527-1.528-.685-1.528-1.527-1.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M377.26,207.817c-1.196,0-2.168-.973-2.168-2.168s.973-2.168,2.168-2.168,2.168,.973,2.168,2.168-.973,2.168-2.168,2.168Zm0-3.696c-.842,0-1.528,.685-1.528,1.528s.685,1.528,1.528,1.528,1.527-.685,1.527-1.528-.685-1.528-1.527-1.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M379.948,200.768h-14.836c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h14.565l1.197-7.064h-17.805c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h18.184c.094,0,.184,.042,.245,.114,.061,.072,.087,.167,.071,.26l-1.306,7.705c-.026,.154-.16,.267-.316,.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M380.601,196.915h-16.51c-.177,0-.32-.143-.32-.32s.143-.32,.32-.32h16.51c.177,0,.32,.143,.32,.32s-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M372.346,200.768c-.177,0-.32-.143-.32-.32v-7.705c0-.177,.143-.32,.32-.32s.32,.143,.32,.32v7.705c0,.177-.143,.32-.32,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M376.224,200.768h-.025c-.176-.015-.308-.169-.294-.345l.602-7.705c.014-.176,.17-.308,.344-.294,.176,.014,.308,.168,.294,.344l-.602,7.705c-.013,.168-.154,.295-.319,.295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M368.651,200.768c-.165,0-.306-.127-.319-.295l-.602-7.705c-.014-.176,.118-.331,.294-.344,.174-.014,.331,.118,.344,.294l.602,7.705c.014,.176-.118,.331-.294,.344h-.025Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-7a563a79-2a0d-45a6-a4b3-036728c808d2",
    d: "M294.276,329.838c0,3.747,3.543,3.544,3.543,3.544h4.836v11.648c0,4.7,4.766,4.767,4.766,4.767,5.178,.068,5.11-4.427,5.11-4.427v-11.784h8.171v11.444s.206,4.971,4.973,4.971,4.973-4.971,4.973-4.971v-11.784h4.972c2.588,0,3.269-3.268,3.269-3.268v-36.712h-44.614v36.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7a563a79-2a0d-45a6-a4b3-036728c808d2",
    d: "M351.558,319.214v-21.08c0-.715-.034-4.87-4.87-4.87s-4.837,4.835-4.837,4.835v20.91c0,1.431,.138,4.75,5.16,4.75s4.546-4.546,4.546-4.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7a563a79-2a0d-45a6-a4b3-036728c808d2",
    d: "M291.041,298.134c0-.715-.034-4.87-4.869-4.87s-4.837,4.835-4.837,4.835v20.91c0,1.431,.136,4.75,5.159,4.75s4.547-4.546,4.547-4.546v-21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7a563a79-2a0d-45a6-a4b3-036728c808d2",
    d: "M327.379,274.35l3.858-5.711c.652-.922-.164-1.142-.164-1.142-.543-.434-.978,.327-.978,.327l-4.002,5.953c-2.803-1.146-5.926-1.795-9.235-1.827-3.418-.034-6.666,.601-9.587,1.773-1.202-1.734-4.312-6.203-4.532-6.333-.27-.164-.653,.164-.653,.164-.705,.543-.38,.815-.38,.815l4.071,6.01c-6.234,3.02-10.689,8.624-11.551,15.483h44.65c-.834-6.88-5.243-12.499-11.497-15.511Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M328.677,281.38c0,1.373-1.112,2.487-2.485,2.487s-2.486-1.114-2.486-2.487,1.113-2.485,2.486-2.485,2.485,1.113,2.485,2.485Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    d: "M309.567,281.38c0,1.373-1.113,2.487-2.485,2.487s-2.487-1.114-2.487-2.487,1.114-2.485,2.487-2.485,2.485,1.113,2.485,2.485Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a",
    x: 284.287,
    y: 450,
    width: 64,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-ba8b48a5-4374-488c-a571-0461e4356078",
    x: 295.763,
    y: 175.342,
    width: 43,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a",
    cx: 182.458,
    cy: 277.171,
    r: 11.829
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a",
    cx: 284.787,
    cy: 452.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a",
    cx: 284.787,
    cy: 452.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-a8a576ab-0ed7-4aae-a6d2-de0eec3e5c4a",
    cx: 347.787,
    cy: 452.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5c653395-6399-4a88-8282-16429f8407e0",
    d: "M432.525,173.454c-.127,.03-.265-.02-.341-.135l-10.476-15.78c-2.955-4.549-1.66-10.65,2.886-13.603,4.546-2.953,10.647-1.658,13.6,2.888l10.475,15.777c.098,.147,.058,.346-.09,.444-.148,.098-.347,.058-.444-.09l-10.476-15.78c-2.763-4.252-8.466-5.464-12.716-2.702-4.25,2.761-5.461,8.464-2.7,12.714l10.474,15.777c.098,.147,.058,.346-.09,.444-.033,.022-.068,.036-.103,.045Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5c653395-6399-4a88-8282-16429f8407e0",
    points: "481.927 191.73 439.036 219.596 414.691 178.396 457.582 150.53 481.927 191.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5c653395-6399-4a88-8282-16429f8407e0",
    d: "M431.227,173.225c.466,.718,.262,1.678-.455,2.144-.718,.466-1.678,.262-2.144-.455-.466-.718-.262-1.678,.455-2.144,.718-.466,1.678-.262,2.144,.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5c653395-6399-4a88-8282-16429f8407e0",
    d: "M447.178,162.862c.466,.718,.262,1.678-.455,2.144-.718,.466-1.678,.262-2.144-.455-.466-.718-.262-1.678,.455-2.144,.718-.466,1.678-.262,2.144,.455Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5c653395-6399-4a88-8282-16429f8407e0",
    points: "481.927 191.73 484.343 186.009 457.582 150.53 481.927 191.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5c653395-6399-4a88-8282-16429f8407e0",
    d: "M430.001,174.381c-.127,.03-.265-.02-.341-.135l-10.476-15.78c-2.955-4.548-1.66-10.65,2.886-13.603,4.546-2.953,10.647-1.658,13.6,2.888l10.474,15.777c.098,.147,.058,.346-.09,.444-.147,.097-.346,.058-.444-.09l-10.476-15.78c-2.763-4.252-8.466-5.464-12.716-2.702-4.25,2.761-5.461,8.464-2.7,12.714l10.474,15.777c.098,.147,.058,.346-.09,.444-.033,.022-.068,.036-.103,.045Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-284bff58-bf2c-42e8-853f-8c5574598704",
    d: "M432.019,338.094c-.157-.007-.289-.13-.303-.291l-1.622-17.571c-.255-2.763,.581-5.46,2.354-7.594,1.774-2.134,4.272-3.45,7.035-3.705,2.761-.255,5.46,.581,7.594,2.354,2.134,1.773,3.45,4.272,3.705,7.035l1.622,17.571c.016,.176-.113,.332-.29,.348-.177,.017-.332-.114-.348-.29l-1.622-17.571c-.239-2.593-1.474-4.937-3.477-6.601-2.002-1.664-4.532-2.449-7.126-2.209-2.593,.239-4.937,1.474-6.601,3.476-1.664,2.002-2.449,4.533-2.209,7.126l1.622,17.571c.016,.176-.113,.332-.29,.348-.015,.001-.03,.002-.045,.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-284bff58-bf2c-42e8-853f-8c5574598704",
    d: "M434.217,337.299c-.157-.007-.289-.13-.303-.291l-1.622-17.571c-.527-5.703,3.685-10.772,9.39-11.299,2.763-.255,5.46,.581,7.594,2.354,2.134,1.773,3.45,4.272,3.705,7.035l1.622,17.571c.016,.176-.114,.332-.29,.348-.178,.016-.332-.114-.348-.29l-1.622-17.571c-.239-2.593-1.474-4.937-3.476-6.601-2.003-1.664-4.533-2.45-7.126-2.209-5.352,.495-9.304,5.251-8.81,10.602l1.622,17.571c.016,.176-.114,.332-.29,.348-.015,.001-.03,.002-.045,.001Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c52e7266-2017-4be4-b9b3-b14ca46e82cb",
    points: "474.195 397.725 422.966 401.964 420.112 330.864 471.342 326.625 474.195 397.725"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-284bff58-bf2c-42e8-853f-8c5574598704",
    points: "474.195 397.725 481.389 391.936 471.342 326.625 474.195 397.725"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-08cf1e04-e64a-430d-bcfd-cf7096b83ea3",
    d: "M196.684,111.934c5.683-6.829,4.5-13.918,4.5-13.918,0,0-7.953,.037-13.674,7.577-5.087,6.705-3.792,12.44-3.792,12.44,0,0,6.898,1.193,12.966-6.099Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-08cf1e04-e64a-430d-bcfd-cf7096b83ea3",
    d: "M203.428,140.265c0-9.886,7.969-13.96,7.969-13.96,0,0-4.074-7.369-14.431-7.369-6.017,0-10.639,3.424-13.13,3.424-2.901,0-7.232-3.218-12.812-3.218-8.584,0-17.737,7.686-17.737,22.339,0,14.893,10.813,33.42,19.371,33.42,2.987,0,7.575-3.009,12.197-3.009,4.536,0,7.883,2.901,12.188,2.901,9.373,0,16.312-19.531,16.312-19.531,0,0-9.927-3.843-9.927-14.995Z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-c2172a0d-5ce6-4ad0-927f-f4dcafa9a167",
    "data-name": "Layer 10"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-6ff2d8da-c662-4dca-ba1d-d4d6e8df8f09",
    "data-name": "Layer 3"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-ca28201e-8f26-417c-b5d3-22905a6d380f",
    "data-name": "Layer 11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApp);
export default __webpack_public_path__ + "static/media/mobile-app.4711be6d6ab807f3cc5cb7409197634a.svg";
export { ForwardRef as ReactComponent };